import { useQuery } from '@tanstack/react-query'
import * as Reakit from 'reakit/Combobox'

import { searchApiRequest } from '../../services/api'
import { link } from '../../services/routing'
import { InstrumentType } from '../../types'
import { Button } from '../button'
import { Centered } from '../centered'
import { Icon } from '../icon'
import { Spinner } from '../spinner'
import { Heading, Paragraph } from '../typography'
import { SearchItem } from './search-item'

interface SearchListProps {
  state: Reakit.unstable_ComboboxStateReturn
  instrument?: InstrumentType
}

export function SearchList(props: SearchListProps) {
  const { data, isLoading } = useQuery(
    ['search', props.state.inputValue, props.instrument],
    () => searchApiRequest(props.state.inputValue, props.instrument),
    { enabled: props.state.inputValue.length > 0, keepPreviousData: true, cacheTime: Infinity, staleTime: Infinity }
  )

  if (isLoading) {
    return (
      <Centered className="h-52 flex-1">
        <Spinner />
      </Centered>
    )
  }

  if (!data?.length) {
    return (
      <Centered className="h-52 flex-1 flex-col">
        <Icon width={24} name="search" className="text-gray-600" />
        <Heading level={5} className="mt-5">
          We couldn’t find any results
        </Heading>
        <Paragraph size="small" className="text-gray-600 dark:text-gray-400">
          Try refining your search and try again.
        </Paragraph>
      </Centered>
    )
  }

  return (
    <div className="flex flex-1 flex-col space-y-2 overflow-hidden">
      <div className="flex grow flex-col overflow-auto">
        {data.map((item) => (
          <SearchItem state={props.state} key={item.ticker} item={item} />
        ))}
      </div>
      <Button
        as="a"
        theme="menuItem"
        className="shrink-0"
        contentClass="text-center"
        href={link.toSearch(encodeURIComponent(props.state.inputValue))}
      >
        Show all results
      </Button>
    </div>
  )
}
